import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParamNames } from 'src/app/core/constantes/http_param-names';
import { Results } from '../../models/server/core/results-T';
import { EmailTemplate } from '../../models/server/email-template';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ViewsStateService } from '../state/views-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class EMailTemplatesService extends ServiceBase {
    /**
     * Constructeur
     * */
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService,
        private viewsStateService: ViewsStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Retourne la liste des modèles de mails d'une vue ainsi que les modèles de mails commun de l'organisation.
     * @param viewId Id de la vue.
     * @returns liste des modèles de mail.
     */
    List(viewId: number): Observable<EmailTemplate[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                sort: this.getHeader(null),
                filters: this.getHeader(null),
                context: this.getHeader(null),
            }),
        };

        let request = new Array<Observable<EmailTemplate[]>>();

        request.push(
            this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/emailtemplates`, httpOptions).pipe(
                map((x) => {
                    var res = Results.getCopyFrom<EmailTemplate>(EmailTemplate, x);
                    return res.value;
                })
            )
        );

        request.push(
            this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/emailtemplates`, httpOptions).pipe(
                map((x) => {
                    var res = Results.getCopyFrom<EmailTemplate>(EmailTemplate, x);
                    return res.value;
                })
            )
        );

        return forkJoin(request).pipe(
            map((responses) => {
                return [].concat(...responses);
            })
        );
    }

    get(emailTemplateId: number, folderId: string): Observable<EmailTemplate> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            params: new HttpParams().set(HttpParamNames.FOLDER_ID, folderId),
        };

        // Appel de la Web Api
        return this.http.get<EmailTemplate>(this.baseUrl + `/api/organizations/${this.organizationId}/emailtemplates/${emailTemplateId}`, httpOptions).pipe(
            map((x) => {
                return x;
            })
        );
    }

    getAttachmentFile(emailTemplateId: number, attachmentId: number, attachmentName: string): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders({}),
            responseType: 'blob' as 'blob',
        };

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/emailtemplates/${emailTemplateId}/attachments/${attachmentId}`, httpOptions).pipe(
            map((x: Blob) => {
                return x;
            })
        );
    }
}
